import { createSlice } from '@reduxjs/toolkit';
import { START_OF_WEEK } from '../../../constents';
import { endOfWeek, formatISO, startOfWeek } from 'date-fns';

export const todoSlice = createSlice({
  name: 'patient',
  initialState: {
    todoPeriodFilter: {
      name: 'week',
      startDate: formatISO(startOfWeek(new Date(), START_OF_WEEK)),
      endDate: formatISO(endOfWeek(new Date(), START_OF_WEEK)),
    },
  },
  reducers: {
    setTodoPeriod: (state, action) => {
      state.todoPeriodFilter = action.payload;
    },
  },
});

export const { setTodoPeriod } = todoSlice.actions;
export default todoSlice.reducer;
